import { render, staticRenderFns } from "./EventsEChart.vue?vue&type=template&id=1198379c&scoped=true&"
import script from "./EventsEChart.vue?vue&type=script&lang=js&"
export * from "./EventsEChart.vue?vue&type=script&lang=js&"
import style0 from "./EventsEChart.vue?vue&type=style&index=0&id=1198379c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1198379c",
  null
  
)

export default component.exports